import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import PageTitle from "../../components/pageTitle/PageTitle";
import { CircularProgress, Container } from "@material-ui/core";
import { Label } from "../../components/ui/label";
import SingleSelectNew from "../../components/SelectField/SingleSelectNew";
import { Input } from "../../components/ui/input";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import AuthContext from "../../hooks/authContext";
import { format } from "date-fns";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import dayjs from "dayjs";
import {
  CheckCircle,
  Clipboard,
  Clock,
  Download,
  Image,
  Mail,
  MapPin,
  Send,
  XCircle,
} from "lucide-react";
import { useMediaQuery } from "@mui/material";
import { Button } from "../../components/ui/button";
import { cn } from "../../components/ui/utils";
import { DatePicker } from "@mui/x-date-pickers";
import {
  downloadImage,
  subscribeToAppointmentsByDates,
} from "../../services/apiservices/appoinments";
import { getCompanyClients } from "../../services/apiservices/client";
import ThemeTable from "../../components/Table/ThemeTable";
import { Badge } from "../../components/ui/badge";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { useToast } from "../../hooks/useToast";
import { handleSendEmail } from "../../services/apiservices/email";
import { Textarea } from "../../components/ui/textArea";

const ProofofWork = () => {
  const isDarkMode = localStorage?.getItem("darkMode") === "true";
  const auth = useContext(AuthContext);
  const [selectedClient, setSelectedClient] = useState("All");
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [employeeSearch, setEmployeeSearch] = useState("");
  const [clientNameList, setClientNameList] = useState([]);
  const [proofOfServiceList, setProofOfServiceList] = useState([]);
  const [rawAppointments, setRawAppointments] = useState([]);
  const [loader, setLoader] = useState(false);
  const [emailLoader, setEmailLoader] = useState(false);
  const [clients, setClients] = useState([]);
  const localClientID = localStorage.getItem("clientId");
  const localCompanyId = localStorage.getItem("companyId");
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [downloadloader, setDownloadLoader] = useState(false);
  const [to, setTo] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [openEmailDialog, setOpenEmailDialog] = useState(false);
  const [emailPhotos, setEmailPhotos] = useState([]);
  const [toError, setToError] = useState(false);
  const isMobile = useMediaQuery("(max-width:767px)");
  const companyId =
    auth?.userProfile?.role === "Client"
      ? localCompanyId
        ? localCompanyId
        : auth?.userProfile?.companyId
      : auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;
  const { toast } = useToast();
  const API_KEY = "AIzaSyCQu0ku4myhKsSAsQ5BX6vseHJ9bPCyAvc";

  const getColumns = () => {
    const columns = [
      {
        id: "employeeName",
        numeric: false,
        disablePadding: false,
        label: "Employee",
        isSortable: false,
        gray: true,
      },
      {
        id: "client",
        numeric: false,
        disablePadding: false,
        label: "Client",
        isSortable: false,
        gray: true,
      },
      {
        id: "date",
        numeric: false,
        disablePadding: false,
        label: "Date",
        isSortable: false,
        gray: true,
      },
      {
        id: "status",
        numeric: false,
        disablePadding: false,
        label: "Status",
        isSortable: false,
        gray: true,
      },
      {
        id: "assigned",
        numeric: false,
        disablePadding: false,
        label: "Tasks Assigned",
        isSortable: false,
        gray: true,
      },
      {
        id: "requested",
        numeric: false,
        disablePadding: false,
        label: "Proof Requested",
        isSortable: false,
        gray: true,
      },
      {
        id: "provided",
        numeric: false,
        disablePadding: false,
        label: "Proof Provided",
        isSortable: false,
        gray: true,
      },
      {
        id: "complete",
        numeric: false,
        disablePadding: false,
        label: "% Complete",
        isSortable: false,
        gray: true,
      },
      {
        id: "photos",
        numeric: false,
        disablePadding: false,
        label: "Photos",
        isSortable: false,
        gray: true,
      },
    ];

    // if (isMobile || isLandscape) {
    //     return columns.filter(col => col.id !== "employeeName" && col.id !== "appointmentDate" && col.id !== "Action");
    // }

    return columns;
  };

  useEffect(() => {
    setLoader(true);

    const startDate = selectedDate.startOf("day").format("YYYY-MM-DDTHH:mm:ss");
    const endDate = selectedDate.endOf("day").format("YYYY-MM-DDTHH:mm:ss");

    const clientId = auth?.userProfile?.role === "Client" ? auth?.userProfile?.client : null;
    const unsubscribe = subscribeToAppointmentsByDates(
      startDate,
      endDate,
      companyId,
      clientId,
      (appointments) => {
        if (appointments?.length > 0) {
          setRawAppointments(appointments || []);
        } else {
           setRawAppointments([]);
        }
      },
      (error) => {
        console.log(error);
        setRawAppointments([]);
      }
    );

    return () => unsubscribe && unsubscribe();
  }, [selectedDate, companyId]);

  useEffect(() => {
    const getClientsData = async () => {
      const [clientRes] = await Promise.all([
        new Promise((resolve) => getCompanyClients(companyId, resolve)),
      ]);

      const details = Array.isArray(clientRes?.data) ? clientRes?.data : [];

      if (auth?.userProfile?.role === "Client") {
        const clientId = auth?.userProfile?.client;

        const client = details?.find((item) => item.id === clientId);
        if (client) {
          const clientOption = {
            value: client?.id,
            label: client?.firstName,
          };

          setClients([client]);
          setClientNameList([clientOption]);
        }
        return;
      }

      const clientOptions = details?.map((item) => ({
        value: item.id,
        label: item.firstName,
      }));

      setClients(details);
      setClientNameList([{ label: "All", value: "All" }, ...clientOptions]);
    };

    if (companyId) {
      getClientsData();
    }
  }, [companyId]);

  const calculatePOSStats = useCallback((appointment) => {
    let totalTasks = 0;
    let requiredPOS = 0;
    let providedPOS = 0;
    let completedTasks = 0;

    const shifts = appointment?.tasks || {};

    Object.values(shifts)?.forEach((shift) => {
      const taskList = shift?.tasksList || [];

      taskList.forEach((task) => {
        totalTasks++;

        if (task?.completed === true) completedTasks++;

        if (task?.pos === true) {
          requiredPOS++;
          if (Array.isArray(task?.proofs) && task?.proofs.length > 0) {
            providedPOS++;
          }
        }
      });
    });

    const percentage =
      requiredPOS === 0 ? 100 : Math.round((providedPOS / requiredPOS) * 100);

    let completionStatus = "None";
    if (completedTasks > 0 && completedTasks < totalTasks) {
      completionStatus = "Partial";
    } else if (totalTasks > 0 && completedTasks === totalTasks) {
      completionStatus = "Completed";
    }

    return {
      totalTasks,
      requiredPOS,
      providedPOS,
      percentage,
      completionStatus,
    };
  }, []);

  const sortingFunction = useCallback((data = []) => {
    return [...data]?.sort((a, b) => {
      if (a.date < b.date) return -1;
      if (a.date > b.date) return 1;
      return a.employeeName?.localeCompare(b.employeeName);
    });
  }, []);

  // const getDistanceInMeters = (lat1, lon1, lat2, lon2) => {
  //   const R = 6371000;
  //   const toRad = (v) => (v * Math.PI) / 180;

  //   const dLat = toRad(lat2 - lat1);
  //   const dLon = toRad(lon2 - lon1);

  //   const a =
  //     Math.sin(dLat / 2) ** 2 +
  //     Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;

  //   return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  // };

  // const buildAddressString = (addressInfo = {}) => {
  //   return [
  //     addressInfo.address,
  //     addressInfo.city,
  //     addressInfo.state,
  //     addressInfo.zip,
  //   ]
  //     .filter(Boolean)
  //     .join(", ");
  // };

  // const geocodeAddress = async (address) => {
  //   const response = await fetch(
  //     `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
  //       address
  //     )}&key=${API_KEY}`
  //   );

  //   const data = await response.json();

  //   if (data.status === "OK") {
  //     const loc = data.results[0].geometry.location;
  //     return { lat: loc.lat, lng: loc.lng };
  //   }

  //   return null;
  // };

  // const geocodeCache = new Map();

  // const geocodeAddressCached = async (address) => {
  //   if (geocodeCache.has(address)) {
  //     return geocodeCache.get(address);
  //   }

  //   const geo = await geocodeAddress(address);
  //   geocodeCache.set(address, geo);
  //   return geo;
  // };

  // const resolveClientLocationAsync = async (clientDetails) => {
  //   const addr = clientDetails?.addressInfo;

  //   if (
  //     addr?.lat &&
  //     addr?.lng &&
  //     !isNaN(Number(addr.lat)) &&
  //     !isNaN(Number(addr.lng))
  //   ) {
  //     return {
  //       lat: Number(addr.lat),
  //       lng: Number(addr.lng),
  //       source: "CLIENT_ADDRESS_STORED",
  //     };
  //   }

  //   const addressString = buildAddressString(addr);
  //   if (addressString) {
  //     const geo = await geocodeAddressCached(addressString);
  //     if (geo) {
  //       return {
  //         lat: geo.lat,
  //         lng: geo.lng,
  //         source: "CLIENT_ADDRESS_GEOCODED",
  //       };
  //     }
  //   }

  //   return null;
  // };

  const reverseGeocodeLatLng = async (lat, lng) => {
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${API_KEY}`
    );

    const data = await response.json();

    if (data.status !== "OK" || !data.results?.length) return null;

    const bestResult =
      data.results.find(
        (r) => r.types.includes("street_address") || r.types.includes("premise")
      ) || data.results[0];

    const components = bestResult.address_components || [];

    const get = (type) =>
      components?.find((c) => c.types.includes(type))?.long_name || "";

    const streetNumber = get("street_number");
    const route = get("route");

    const addressLine = [streetNumber, route].filter(Boolean).join(" ");

    return {
      address: addressLine,
      city: get("locality") || get("administrative_area_level_2"),
      state: get("administrative_area_level_1"),
      country: get("country"),
      zip: get("postal_code"),
      formattedAddress: bestResult.formatted_address,
    };
  };

  const reverseGeoCache = new Map();

  const normalizeCoord = (v) => Number(v).toFixed(4);

  const reverseGeocodeCached = async (lat, lng) => {
    const key = `${normalizeCoord(lat)},${normalizeCoord(lng)}`;

    if (reverseGeoCache.has(key)) {
      return reverseGeoCache.get(key);
    }

    const address = await reverseGeocodeLatLng(lat, lng);

    reverseGeoCache.set(key, address);

    return address;
  };

  const clientMap = useMemo(() => {
    const map = new Map();
    clients?.forEach((c) => map.set(c.id, c));
    return map;
  }, [clients]);

  const buildPOSForAppointment = async (appointment) => {
    const tasks = [];
    const shifts = appointment?.tasks || {};

    for (const shift of Object.values(shifts)) {
      for (const task of shift?.tasksList || []) {
        for (const proof of task?.proofs || []) {
          if (!proof?.gps || !proof?.url) continue;

          tasks.push(
            (async () => {
              const proofAddress = await reverseGeocodeCached(
                proof.gps.lat,
                proof.gps.lng
              );

              return {
                taskId: task?.taskId,
                taskTitle: task?.title,
                proofUrl: proof?.url,
                capturedAt: proof?.captured_at_device,
                uploadedAt: proof?.uploaded_at,
                proofGPS: proof?.gps,
                verified: proof?.verified,
                proofAddress,
              };
            })()
          );
        }
      }
    }

    return Promise.all(tasks);
  };


  const transformVersionRef = useRef(0);

  const applyFiltersAndTransform = useCallback(async () => {
    const currentVersion = ++transformVersionRef.current;

    const filtered = rawAppointments?.filter((item) => {
      let ok = true;

      if (selectedClient !== "All") {
        ok = item?.clientId === selectedClient;
      }

      if (ok && employeeSearch) {
        ok = item?.apoointmentDetails?.calendar
          ?.toLowerCase()
          ?.includes(employeeSearch.toLowerCase());
      }

      return ok;
    });

    const mapped = await Promise.all(
      filtered?.map(async (appointment) => {
        const clientDetails = clientMap.get(appointment.clientId);

        const posProofs = await buildPOSForAppointment(appointment);

        return {
          ...appointment,
          employeeName: appointment?.apoointmentDetails?.calendar,
          employeNameId: appointment?.userId,
          date: appointment?.apoointmentDetails?.date,
          client: clientDetails?.clientName || "-",
          posStats: calculatePOSStats(appointment),
          verifiedPOS: posProofs,
        };
      })
    );

    if (currentVersion !== transformVersionRef.current) return;
    setProofOfServiceList(sortingFunction(mapped));
    setLoader(false);
  }, [
    rawAppointments,
    selectedClient,
    employeeSearch,
    clientMap
  ]);

  useEffect(() => {
    if (!rawAppointments?.length) {
      setProofOfServiceList([]);
      setLoader(false);
      return;
    }

    applyFiltersAndTransform();
  }, [rawAppointments, selectedClient, employeeSearch]);

  const getStatusBadge = (status) => {
    const variants = {
      Completed: {
        className:
          "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400",
      },
      Partial: {
        className:
          "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400",
      },
      None: {
        className:
          "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400",
      },
    };
    return (
      <Badge
        variant="outline"
        className={cn("font-medium", variants[status]?.className)}
      >
        {status}
      </Badge>
    );
  };

  const handleViewPhotos = (record) => {
    if (record?.verifiedPOS?.length > 0) {
      setSelectedRecord(record);
      setSelectedPhoto(record?.verifiedPOS?.[0]);
    }
  };

  const handleEmail = (photos) => {
    setSelectedPhoto(null);
    setEmailPhotos(Array.isArray(photos) ? photos : [photos]);
    setOpenEmailDialog(true);
  };

 const SendEmail = async () => {
   if (!to) {
     toast({
       title: "Email required",
       description: "Please enter recipient email address.",
       variant: "destructive",
     });
     return;
   }

   if (!emailPhotos?.length) {
     toast({
       title: "No photo selected",
       description: "Please select at least one photo to send.",
       variant: "destructive",
     });
     return;
   }

   try {
     setEmailLoader(true);

     await handleSendEmail(emailPhotos, to, subject, message);

     toast({
       title: "Email sent successfully",
       description: `Proof photo sent to ${to}`,
     });

     handleCancel();
   } catch (error) {
     console.error("Send email failed", error);

     toast({
       title: "Email failed",
       description:
         error?.message || "Something went wrong while sending the email.",
       variant: "destructive",
     });
   } finally {
     setEmailLoader(false);
   }
 };


  const handleCancel = () => {
    setOpenEmailDialog(false);
    setEmailPhotos([]);
    setTo("");
    setSubject("");
    setMessage("");
  };


  const handleDownload = async (photo) => {
    try {
      setDownloadLoader(true);
      const blob = await downloadImage(photo?.proofUrl);
      
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `${photo?.taskTitle || "proof"}-${format(photo?.capturedAt, "yyyy-MM-dd-HHmm")}.jpg`;
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);

      toast({
        title: "Download Complete",
        description: "Your photo has been downloaded successfully.",
        variant: "default",
      });
      setDownloadLoader(false);
    } catch (error) {
      console.error("Download error:", error);
      setDownloadLoader(false);
      toast({
        title: "Download Failed",
        description: "Failed to download the image. Please try again.",
        variant: "destructive",
      });
    }
  };

  const getPhotoVerificationBadge = (isVerified) => {
    if (isVerified) {
      return (
        <Badge className="bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400 gap-1">
          <CheckCircle className="h-3 w-3" />
          Verified
        </Badge>
      );
    }
    return (
      <Badge className="bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400 gap-1">
        <XCircle className="h-3 w-3" />
        Unverified
      </Badge>
    );
  };

  const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
    switch (hcellItem.id) {
      case "status":
        return getStatusBadge(rcellItem?.posStats?.completionStatus);
        break;
      case "requested":
        return <div>{rcellItem?.posStats?.requiredPOS}</div>;
        break;
      case "assigned":
        return <div>{rcellItem?.posStats?.totalTasks}</div>;
        break;
      case "provided":
        return <div>{rcellItem?.posStats?.providedPOS}</div>;
        break;
      case "complete":
        return <div>{rcellItem?.posStats?.percentage}%</div>;
        break;
      case "photos":
        return (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => handleViewPhotos(rcellItem)}
            disabled={rcellItem?.verifiedPOS?.length === 0}
            className="h-8 w-8 p-0"
          >
            <Image className="h-4 w-4" />
          </Button>
        );
        break;
      default:
        return <div className="b-none">{rcellItem[hcellItem?.id]}</div>;
    }
  };

  const openInMaps = (location) => {
    const url = `https://www.google.com/maps?q=${location.lat},${location.lng}`;
    window.open(url, "_blank");
  };

  function validateEmail(emailList) {
    const emails = emailList
        .split(",")
        .map((e) => e.trim())
        .filter((e) => e !== "");

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const invalidSequenceRegex = /[\/]{1}|\.{2,}|\/\.|\.\/|[^a-zA-Z0-9._%+-@]/;

    for (let email of emails) {
        if (!emailRegex.test(email)) {
        return `Invalid format: ${email}`;
        }
        if (invalidSequenceRegex.test(email)) {
        return `Invalid characters in: ${email}`;
        }
    }

    return "";
    }

  return (
    <Container>
      <PageTitle
        pageTitle="Proof of Work"
        showBreadcrumb={[{ label: "Home", to: "/" }, { label: "Operations" }]}
        BreadCrumbCurrentPageTitle={"Proof of Work"}
        showLastSeen={true}
      />

      <Card className="shadow-sm dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] p-24 m-30">
        <CardHeader className="pb-16">
          <CardTitle className="text-lg">Filters</CardTitle>
        </CardHeader>
        <CardContent className="pb-24 ph-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {auth?.userProfile?.role !== "Client" && (
            <div className="flex flex-col space-y-1">
              <Label
                htmlFor="company"
                className="text-sm font-medium text-gray-700 dark:text-white"
              >
                Client Name
              </Label>
              <SingleSelectNew
                contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                value={selectedClient}
                options={clientNameList}
                name={"clientName"}
                label={"Client Name"}
                onChange={(e) => setSelectedClient(e)}
              />
            </div>
          )}

            <div className="flex flex-col space-y-1">
              <Label
                htmlFor="Date"
                className="text-sm font-medium text-gray-700 dark:text-white"
              >
                Date
              </Label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={selectedDate}
                  onChange={(newValue) => {
                    setSelectedDate(newValue);
                  }}
                  views={["year", "month", "day"]}
                  inputFormat="YYYY-MM-DD"
                  slotProps={{
                    textField: {
                      variant: "outlined",
                      size: "small",
                      fullWidth: true,
                      className: "customDateInput",
                    },
                  }}
                />
              </LocalizationProvider>
            </div>

            <div className="flex flex-col space-y-1">
              <Label
                htmlFor="employee"
                className="text-sm font-medium text-gray-700 dark:text-white"
              >
                Employee Name
              </Label>
              <Input
                id="employee"
                placeholder="Search employee..."
                value={employeeSearch}
                onChange={(e) => setEmployeeSearch(e.target.value)}
              />
            </div>
          </div>
        </CardContent>
      </Card>

      {loader ? (
        <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px] mh-30 mv-30">
          <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
            Fetching data...
          </div>
        </Card>
      ) : proofOfServiceList?.length === 0 ? (
        <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px] mh-30 mv-30">
          <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
            No Records Found
          </div>
        </Card>
      ) : (
        proofOfServiceList?.length > 0 && (
          <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] mh-30 mv-30">
            <CardHeader className="pb-16">
              <div className="flex flex-col space-y-4 lg:flex-row lg:items-start lg:justify-between lg:space-y-0">
                <div className="space-y-3 flex-1 min-w-0">
                  <CardTitle className="text-lg sm:text-xl">Results</CardTitle>
                </div>
              </div>
            </CardHeader>
            <CardContent className="p-0 sm:p-6 sm:pt-0">
              {!isMobile && (
                <ThemeTable
                  rows={proofOfServiceList}
                  headCells={getColumns()}
                  hidePagination={true}
                  // isLoading={isLoading}
                  renderRowCell={renderRowCell}
                />
              )}

              {isMobile && (
                <div className="space-y-4">
                  {proofOfServiceList?.length === 0 ? (
                    <p className="text-center text-muted-foreground py-8">
                      No results found
                    </p>
                  ) : (
                    proofOfServiceList?.map((item) => (
                      <Card
                        key={item?.id}
                        className="shadow-sm p-10 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]"
                      >
                        <CardContent className="p-16 space-y-3">
                          <div className="flex justify-between items-start">
                            <div>
                              <p className="font-semibold text-foreground">
                                {item?.employeeName}
                              </p>
                              <p className="text-sm text-muted-foreground">
                                {item?.client}
                              </p>
                            </div>
                            {getStatusBadge(item?.posStats?.completionStatus)}
                          </div>
                          <div className="text-sm text-muted-foreground">
                            {item?.date}
                          </div>
                          <div className="grid grid-cols-2 gap-2 text-sm">
                            <div>
                              <span className="text-muted-foreground">
                                Tasks Assigned:
                              </span>
                              <span className="ml-8 font-medium">
                                {item?.posStats?.totalTasks}
                              </span>
                            </div>
                            <div>
                              <span className="text-muted-foreground">
                                Proof Requested:
                              </span>
                              <span className="ml-8 font-medium">
                                {item?.posStats?.requiredPOS}
                              </span>
                            </div>
                            <div>
                              <span className="text-muted-foreground">
                                Proof Provided:
                              </span>
                              <span className="ml-8 font-medium">
                                {item?.posStats?.providedPOS}
                              </span>
                            </div>
                            <div>
                              <span className="text-muted-foreground">
                                % Complete:
                              </span>
                              <span className="ml-8 font-medium">
                                {item?.posStats?.percentage}%
                              </span>
                            </div>
                          </div>
                          <Button
                            variant="outline"
                            size="sm"
                            className="w-full"
                            onClick={() => handleViewPhotos(item)}
                            disabled={item?.verifiedPOS?.length === 0}
                          >
                            <Image className="h-4 w-4 mr-8" />
                            View Photos ({item?.verifiedPOS?.length})
                          </Button>
                        </CardContent>
                      </Card>
                    ))
                  )}
                </div>
              )}
            </CardContent>
          </Card>
        )
      )}

      <Dialog
        open={!!selectedPhoto}
        onOpenChange={(open) => !open && setSelectedPhoto(null)}
      >
        <DialogContent className="w-full max-w-[95vw] sm:max-w-2xl lg:max-w-4xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-3">
              <span className="dark:text-white">Proof Photo</span>
              {selectedPhoto &&
                getPhotoVerificationBadge(selectedPhoto?.verified)}
            </DialogTitle>
          </DialogHeader>
          {selectedPhoto && selectedRecord && (
            <div className="space-y-4">
              <div className="w-full flex justify-center">
                <div
                  className="rounded-lg overflow-hidden"
                  style={{ maxHeight: "40vh", width: "auto" }}
                >
                  <img
                    src={selectedPhoto?.proofUrl}
                    alt="Proof of work"
                    className="max-w-full max-h-[60vh] object-contain"
                  />
                </div>
              </div>

              <div className="space-y-3">
                {selectedPhoto?.taskTitle && (
                  <div className="flex items-center gap-2 text-sm">
                    <Clipboard className="h-4 w-4 text-muted-foreground" />
                    <span className="text-muted-foreground">Task:</span>
                    <span className="font-medium dark:text-white">
                      {selectedPhoto?.taskTitle}
                    </span>
                  </div>
                )}
                <div className="flex items-center gap-2 text-sm">
                  <Clock className="h-4 w-4 text-muted-foreground" />
                  <span className="text-muted-foreground">Timestamp:</span>
                  <span className="font-medium dark:text-white">
                    {format(selectedPhoto?.capturedAt, "PPpp")}
                  </span>
                </div>
                <div className="flex items-start gap-2 text-sm w-full">
                  <MapPin className="h-4 w-4 text-muted-foreground mt-2" />
                  <span className="text-muted-foreground">Location:</span>
                  <Button
                    variant="link"
                    className="p-0 h-auto font-medium text-primary"
                    onClick={() => openInMaps(selectedPhoto?.proofGPS)}
                  >
                    <span
                      className="dark:text-green-500"
                      style={{ wordBreak: "break-all" }}
                    >
                      {selectedPhoto?.proofAddress?.formattedAddress}
                    </span>
                  </Button>
                </div>
              </div>

              {selectedRecord?.verifiedPOS?.length > 1 && (
                <div className="flex items-center justify-center gap-2">
                  {selectedRecord?.verifiedPOS?.map((photo, index) => (
                    <Button
                      key={photo?.taskId}
                      variant={
                        selectedPhoto?.taskId === photo?.taskId
                          ? "default"
                          : "outline"
                      }
                      size="sm"
                      onClick={() => setSelectedPhoto(photo)}
                      className="h-8 w-8 p-0"
                    >
                      {index + 1}
                    </Button>
                  ))}
                </div>
              )}

              <div className="flex flex-col sm:flex-row gap-2 pt-8">
                <Button
                  variant="outline"
                  className="flex-1"
                  onClick={() => handleDownload(selectedPhoto)}
                >
                  {downloadloader ? (
                    <CircularProgress size={20} className="dark:text-white" />
                  ) : (
                    <>
                      <Download className="h-4 w-4 mr-2" />
                      <span>Download Photo</span>
                    </>
                  )}
                </Button>
                <Button
                  variant="outline"
                  className="flex-1"
                  onClick={() => {
                    handleEmail([selectedPhoto]);
                  }}
                >
                  <Mail className="h-4 w-4 mr-8" />
                  Email Photo
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      <Dialog open={openEmailDialog} onOpenChange={handleCancel} fullWidth maxWidth="md">
        <DialogContent className="w-full max-w-[80vw] sm:max-w-2xl lg:max-w-2xl max-h-[80vh] overflow-y-auto">
          <DialogTitle className="dark:text-white">Email Photo</DialogTitle>
          <>
            <div>
              {emailPhotos?.length > 0 && (
                <div className="mb-20 p-12 border rounded-lg bg-muted">
                  <div className="flex gap-12 items-start">
                    
                    <img
                      src={emailPhotos?.[0]?.proofUrl}
                      alt="Proof"
                      style={{ width: "200px", height: "180px" }}
                      className="object-cover rounded-md border"
                    />

                    <div className="flex flex-col gap-6 text-sm">
                      <div className="dark:text-white">
                        <strong className="text-muted-foreground">Task:</strong>{" "}
                        <span>{emailPhotos?.[0]?.taskTitle}</span>
                      </div>

                      <div className="dark:text-white">
                        <strong className="text-muted-foreground">Captured At:</strong>{" "}
                        <span>
                          {format(emailPhotos?.[0]?.capturedAt, "PPpp")}
                        </span>
                      </div>

                      <div className="dark:text-white">
                        <strong className="text-muted-foreground">Location:</strong>{" "}
                        <span>
                          {emailPhotos[0]?.proofAddress?.formattedAddress}
                        </span>
                      </div>

                      <div className="dark:text-white">
                        <strong className="text-muted-foreground">Status:</strong>{" "}
                        {emailPhotos?.[0]?.verified ? (
                          <span className="text-green-600">Verified</span>
                        ) : (
                          <span className="text-red-600">Not Verified</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="mb-20">
                <Input
                  fullWidth
                  size="small"
                  name="To"
                  id="to"
                  label="To"
                  variant="outlined"
                  value={to}
                  onChange={(e) => {
                    const value = e.target.value;
                    setTo(value);
                    const errorMsg = validateEmail(value);
                    setToError(errorMsg);
                  }}
                  placeholder="To"
                  error={toError}
                  helperText={toError ? toError : ""}
                  disabled={emailLoader}
                />
              </div>
              <div className="mb-20">
                <Input
                  fullWidth
                  size="small"
                  name="Subject"
                  id="subject"
                  label="Subject"
                  variant="outlined"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  placeholder="Subject"
                  disabled={emailLoader}
                />
              </div>
              <div className="mb-20">
                <Textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  fullWidth
                  id="description"
                  label="Add Description"
                  multiline
                  rows={4}
                  variant="outlined"
                  placeholder="Add Description"
                  disabled={emailLoader}
                />
              </div>
            </div>
          </>

          <div className="flex flex-col sm:flex-row gap-2 sm:justify-end pt-12 border-t">
            <Button
              type="button"
              variant="outline"
              onClick={handleCancel}
              className="h-10 text-sm"
            >
              Cancel
            </Button>
            <Button type="submit" className="h-10 text-sm" onClick={SendEmail}>
              {emailLoader ? (
                <CircularProgress size={24} style={{ color: "white" }} />
              ) : (
                <span className="d-flex flex-center">
                  {" "}
                  <Send className="w-4 h-4 mr-8" /> Send{" "}
                </span>
              )}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </Container>
  );
};

export default ProofofWork;
